import P from 'app/common/lib/P';

const app = {};

/** @type {?Module} */
app.instance = null;

/**
 * @param {!Module} newApp
 */
app.set = function(newApp) {
  app.instance = newApp;
};

// eslint-disable-next-line pinterest/no-referencing-p-properties
export default P.expose('app', app);
